import { render, staticRenderFns } from "./minichart.vue?vue&type=template&id=e3fdfe08&scoped=true&"
import script from "./minichart.vue?vue&type=script&lang=js&"
export * from "./minichart.vue?vue&type=script&lang=js&"
import style0 from "./minichart.vue?vue&type=style&index=0&id=e3fdfe08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fdfe08",
  null
  
)

export default component.exports